import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { SERVICES, IMAGES, COMPANY } from "@/lib/company";

export default function Services() {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="bg-slate-900" data-testid="services-header">
        <div className="mx-auto max-w-7xl px-4 py-12">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white">Transportation Services</h1>
          <p className="mt-2 text-slate-300 max-w-2xl">
            {COMPANY.name} coordinates vehicle transport and automotive logistics for individuals,
            dealerships, and businesses.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-4 py-14">
        <div className="relative rounded-md overflow-hidden border border-slate-200 mb-12">
          <img src={IMAGES.enclosedHauler} alt="Vehicles loaded for transport" className="w-full h-64 object-cover" />
        </div>

        <div className="space-y-10" data-testid="services-list">
          {SERVICES.map((s, i) => (
            <div key={s.key} className="border-b border-slate-200 pb-10 last:border-0" data-testid={`service-${s.key}`}>
              <div className="flex items-baseline gap-3">
                <span className="text-sm font-mono text-slate-400">0{i + 1}</span>
                <h2 className="text-xl sm:text-2xl font-bold text-slate-900">{s.title}</h2>
              </div>
              <p className="mt-3 text-slate-700 leading-relaxed max-w-3xl">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-slate-50 border border-slate-200 rounded-md p-8 text-center">
          <h3 className="text-xl font-bold text-slate-900">Request a Transport Quote</h3>
          <p className="mt-2 text-slate-600 max-w-xl mx-auto">
            Tell us the pickup location, delivery location, and vehicle details, and we will follow
            up with transport options and pricing.
          </p>
          <div className="mt-5 flex flex-col sm:flex-row gap-3 justify-center">
            <button onClick={() => navigate("/contact?type=Transportation%20Quote")} data-testid="services-quote-btn" className="rounded-md bg-blue-800 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-900">
              Request a Transport Quote
            </button>
            <button onClick={() => navigate("/catalog")} data-testid="services-browse-btn" className="rounded-md border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-800 hover:border-blue-700">
              Browse Available Vehicles
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
